import React from "react";
import "./Certificats.scss";
import { User } from "../../../../Dashboard";

export default class Certificats extends React.Component<{}, {
  search: string;
  blur: boolean;
  certificats: any[];
  reverse: boolean;
}> {
  constructor(props: {}) {
    super(props);
    this.state = {
      search: '',
      blur: true,
      certificats: [],
      reverse: false
    };
  }

  checkDocument(document: string) {
    const dniRegex = /^\d{8}[A-HJ-NP-TV-Z]$/i;
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    if (dniRegex.test(document)) {
      const number = parseInt(document.slice(0, 8), 10);
      const letter = document.slice(8).toUpperCase();
      return letters[number % 23] === letter;
    }
    const nieRegex = /^[XYZ]\d{7}[A-HJ-NP-TV-Z]$/i;
    if (nieRegex.test(document)) {
      const number = Number(`${{ X: 0, Y: 1, Z: 2 }[document.charAt(0)]}${document.slice(1, 8)}`);
      const letter = document.slice(8).toUpperCase();
      return letters[number % 23] === letter;
    }
    if (!nieRegex.test(document) && !dniRegex.test(document)) {
      return true;
    }
    return false;
  }

  getQuotes() {
    fetch('https://api.castellersdemollet.cat/certificats')
      .then(response => response.json())
      .then(data => {
        this.setState({ certificats: data });
      })
      .catch(error => {
        throw new Error(`Error fetching dynamic links: ${error}`);
      });
  }

  componentDidMount() {
    this.getQuotes()
  }

  postQuota(document) {
    if (!this.state.search) return;
    fetch('https://api.castellersdemollet.cat/certificats', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        document: document,
        estat: true
      })
    })
      .then(() => {
        this.setState({
          certificats: [...this.state.certificats, {
            document: document,
            estat: true,
          }]
        });
      })
      .catch(error => {
        throw new Error(`Error posting dynamic link: ${error}`);
      });
  }

  putQuota(doc: string, estat: boolean) {
    fetch(`https://api.castellersdemollet.cat/certificats?doc=${doc}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        estat: estat
      })
    })
      .then(() => {
        this.setState({
          certificats: this.state.certificats.map(certificat =>
            certificat.document === doc ? { ...certificat, estat } : certificat
          )
        });
      })
      .catch(error => {
        throw new Error(`Error updating dynamic link: ${error}`);
      });
  }

  deleteQuota(doc: string) {
    fetch(`https://api.castellersdemollet.cat/certificats?doc=${doc}`, {
      method: 'DELETE'
    })
      .then(() => {
        this.setState({ certificats: this.state.certificats.filter(certificat => certificat.document !== this.state.search) });
      })
      .catch(error => {
        throw new Error(`Error deleting dynamic link: ${error}`);
      });
  }

  render() {
    return (
      <User.Consumer>
        {
          (ctx) => {
            const { certificats, blur, reverse } = this.state;
            const sorted = certificats.sort((a, b) => a.estat - b.estat).sort((a, b) => b.document.includes(this.state.search) - a.document.includes(this.state.search));
            return (
              <div className="certificats" style={{ '--accent': ctx.accent } as React.CSSProperties}>
                <h1>Certificats de Delictes Sexuals</h1>
                <div className="data">
                  <button className="toggleBlur" onClick={() => this.setState({ blur: !blur })}>
                    <svg className={blur && 'active'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M19.439 15.439C20.3636 14.5212 21.0775 13.6091 21.544 12.955C21.848 12.5287 22 12.3155 22 12C22 11.6845 21.848 11.4713 21.544 11.045C20.1779 9.12944 16.6892 5 12 5C11.0922 5 10.2294 5.15476 9.41827 5.41827M6.74742 6.74742C4.73118 8.1072 3.24215 9.94266 2.45604 11.045C2.15201 11.4713 2 11.6845 2 12C2 12.3155 2.15201 12.5287 2.45604 12.955C3.8221 14.8706 7.31078 19 12 19C13.9908 19 15.7651 18.2557 17.2526 17.2526" />
                      <path d="M9.85786 10C9.32783 10.53 9 11.2623 9 12.0711C9 13.6887 10.3113 15 11.9289 15C12.7377 15 13.47 14.6722 14 14.1421" />
                      <path d="M3 3L21 21" />
                    </svg>
                    <svg className={!blur && 'active'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5">
                      <path d="M21.544 11.045C21.848 11.4713 22 11.6845 22 12C22 12.3155 21.848 12.5287 21.544 12.955C20.1779 14.8706 16.6892 19 12 19C7.31078 19 3.8221 14.8706 2.45604 12.955C2.15201 12.5287 2 12.3155 2 12C2 11.6845 2.15201 11.4713 2.45604 11.045C3.8221 9.12944 7.31078 5 12 5C16.6892 5 20.1779 9.12944 21.544 11.045Z" />
                      <path d="M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z" />
                    </svg>
                  </button>
                  <button className="toggleDirection" onClick={() => this.setState({ reverse: !reverse })}>
                    <svg className={reverse && 'active'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M6.99988 21.0003V14.9491C6.99988 14.3746 6.99988 14.0873 6.76947 14.0158C6.26294 13.8587 5.49988 15 5.49988 15M6.99988 21.0003H5.49988M6.99988 21.0003H8.49988" />
                      <path d="M8.99988 6.50098V4.75098C8.99988 3.92602 8.99988 3.51354 8.70698 3.25726C8.41409 3.00098 7.94269 3.00098 6.99988 3.00098C6.05707 3.00098 5.58566 3.00098 5.29277 3.25726C4.99988 3.51354 4.99988 3.92602 4.99988 4.75098C4.99988 5.57593 4.99988 5.98841 5.29277 6.2447C5.58566 6.50098 6.05707 6.50098 6.99988 6.50098H8.99988ZM8.99988 6.50098V7.37598C8.99988 8.61341 8.99988 9.23213 8.56054 9.61655C8.1212 10.001 7.41409 10.001 5.99988 10.001H4.99988" />
                      <path d="M16.4999 20V4M16.4999 20C15.7997 20 14.4915 18.0057 13.9999 17.5M16.4999 20C17.2002 20 18.5084 18.0057 18.9999 17.5" />
                    </svg>
                    <svg className={!reverse && 'active'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M7 10.0002V3.94897C7 3.37446 7 3.0872 6.76959 3.01571C6.26306 2.85855 5.5 3.99988 5.5 3.99988M7 10.0002H5.5M7 10.0002H8.5" />
                      <path d="M9 17.5V15.75C9 14.925 9 14.5126 8.70711 14.2563C8.41421 14 7.94281 14 7 14C6.05719 14 5.58579 14 5.29289 14.2563C5 14.5126 5 14.925 5 15.75C5 16.575 5 16.9874 5.29289 17.2437C5.58579 17.5 6.05719 17.5 7 17.5H9ZM9 17.5V18.375C9 19.6124 9 20.2312 8.56066 20.6156C8.12132 21 7.41421 21 6 21H5" />
                      <path d="M16.5 20V4M16.5 20C15.7998 20 14.4915 18.0057 14 17.5M16.5 20C17.2002 20 18.5085 18.0057 19 17.5" />
                    </svg>
                  </button>
                  <span className="totals" data-label="totals">
                    {certificats.length}
                  </span>
                  <span className="pagats" data-label="rebuts">
                    {certificats.filter(key => key.estat).length}
                  </span>
                  <span className="pendents" data-label="pendents">
                    {certificats.filter(key => !key.estat).length}
                  </span>
                </div>
                <section className="options">
                  <input type="text" onInput={
                    (event) => {
                      this.setState({
                        search: (event.target as HTMLInputElement).value
                      });
                    }
                  } placeholder="Cerca..." value={this.state?.search} />
                  {
                    this.state.search.length >= 9 && this.checkDocument(this.state.search) && !certificats?.some((v) => v.document === this.state.search) && (
                      <button className="success" onClick={
                        () => {
                          this.postQuota(this.state.search)
                        }
                      }>Afegir</button>
                    )
                  }
                  {
                    this.state.search.length >= 9 && this.checkDocument(this.state.search) && certificats?.some((v) => v.document === this.state.search) && (
                      <>
                        {
                          !Boolean(certificats?.find((v) => v.document === this.state.search).estat) && (
                            <button className="success" onClick={
                              () => {
                                this.putQuota(this.state.search, true)
                              }
                            }>Rebut</button>
                          )
                        }
                        {
                          Boolean(certificats?.find((v) => v.document === this.state.search).estat) && (
                            <button className="danger" onClick={
                              () => {
                                this.putQuota(this.state.search, false)
                              }
                            }>Pendent</button>
                          )
                        }
                        <button className="danger" onClick={
                          () => {
                            this.deleteQuota(this.state.search)
                          }
                        }>Eliminar</button>
                      </>
                    )
                  }
                  {this.state.search.length < 9 && (
                    <p className="info">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 16V12" />
                        <path d="M12.125 8.25H12M12.25 8.25C12.25 8.11193 12.1381 8 12 8C11.8619 8 11.75 8.11193 11.75 8.25C11.75 8.38807 11.8619 8.5 12 8.5C12.1381 8.5 12.25 8.38807 12.25 8.25Z" />
                      </svg>
                      Introdueix un document válid per a afegir-ho o modificar-ho.
                    </p>
                  )}
                  {this.state.search.length >= 9 && !this.checkDocument(this.state.search) && (
                    <p className="danger">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 16V12" />
                        <path d="M12.125 8.25H12M12.25 8.25C12.25 8.11193 12.1381 8 12 8C11.8619 8 11.75 8.11193 11.75 8.25C11.75 8.38807 11.8619 8.5 12 8.5C12.1381 8.5 12.25 8.38807 12.25 8.25Z" />
                      </svg>
                      Aquest document d'identitat no te un format válid.
                    </p>
                  )}
                </section>
                <ul className="llista">
                  {
                    (reverse ? sorted.reverse() : sorted)
                      .map((certificat, index) => {
                        const { document, estat } = certificat;
                        return (
                          <li key={index} className={`certificat ${estat ? 'pagat' : 'pendent'} ${blur ? 'blurOn' : 'blurOff'} ${document.includes((this.state?.search.length < 1 ? null : this.state.search)) ? 'searched' : ''} ${document === this.state.search || document === this.state.search ? 'exact' : ''}`}>
                            {
                              estat ? (
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                                  <path d="M11 20H10.5C6.74142 20 4.86213 20 3.60746 19.0091C3.40678 18.8506 3.22119 18.676 3.0528 18.4871C2 17.3062 2 15.5375 2 12C2 8.46252 2 6.69377 3.0528 5.5129C3.22119 5.32403 3.40678 5.14935 3.60746 4.99087C4.86213 4 6.74142 4 10.5 4H13.5C17.2586 4 19.1379 4 20.3925 4.99087C20.5932 5.14935 20.7788 5.32403 20.9472 5.5129C21.8957 6.57684 21.9897 8.11799 21.999 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M2 9H22" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                                  <path d="M14 18C14 18 15 18 16 20C16 20 19.1765 15 22 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                                  <path d="M12.5 20H10.5C6.74142 20 4.86213 20 3.60746 19.0091C3.40678 18.8506 3.22119 18.676 3.0528 18.4871C2 17.3062 2 15.5375 2 12C2 8.46252 2 6.69377 3.0528 5.5129C3.22119 5.32403 3.40678 5.14935 3.60746 4.99087C4.86213 4 6.74142 4 10.5 4H13.5C17.2586 4 19.1379 4 20.3925 4.99087C20.5932 5.14935 20.7788 5.32403 20.9472 5.5129C21.8957 6.57684 21.9897 8.11799 21.999 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M2 9H22" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                                  <path d="M22 14L16 20M22 20L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                </svg>
                              )
                            }
                            <span>{document}</span>
                          </li>
                        );
                      })
                  }
                </ul>
              </div>
            )
          }
        }
      </User.Consumer>
    );
  }
}